
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "LinePreload"
})
export default class LinePreload extends Vue {
  @Prop({ default: 1 })
  line: number;
  @Prop({ default: 400 })
  w: number;
  @Prop({ default: 20 })
  h: number;
  @Prop({ default: 0 })
  r: number;
  @Prop({ default: false })
  isL: boolean;
  @Prop({ default: "" })
  bindClass: string;

  getLineStyle() {
    return `height: ${this.getHeight()}px`;
  }

  getHeight() {
    return this.h * this.line * 2 - this.h;
  }
}
